(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["move-baseline-socks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('move-socks-offer')) {
    customElements.define('move-socks-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const storageKey = 'move-baseline-socks-dismissed-v1';
        let rememberDisclosure = () => {};
        if (this.hasAttribute('data-compact-mobile')) {
          const mobile = window.matchMedia('(max-width: 767px)');
          const activeKey = () => mobile.matches ? 'move-baseline-socks-full-cart-mobile-dismissed-v1' : storageKey;
          const restoreDisclosure = () => {
            let dismissed = null;
            try { dismissed = sessionStorage.getItem(activeKey()); } catch (_) {}
            const open = dismissed === null ? !mobile.matches : dismissed !== 'true';
            if (!open && details.contains(document.activeElement)) summary.focus();
            details.open = open;
          };
          rememberDisclosure = open => {
            try { sessionStorage.setItem(activeKey(), String(!open)); } catch (_) {}
          };
          summary.addEventListener('click', () => rememberDisclosure(!details.open), options);
          mobile.addEventListener('change', restoreDisclosure, options);
          restoreDisclosure();
        } else {
          try { if (sessionStorage.getItem(storageKey) === 'true') details.open = false; } catch (_) {}
          details.addEventListener('toggle', () => {
            try { sessionStorage.setItem(storageKey, String(!details.open)); } catch (_) {}
          }, options);
        }
        this.querySelectorAll('[data-socks-color]').forEach(button => {
          button.addEventListener('click', () => {
            const id = button.dataset.socksColor;
            this.querySelectorAll('[data-socks-color]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
            this.querySelectorAll('[data-socks-panel]').forEach(panel => { panel.hidden = panel.dataset.socksPanel !== id; });
          }, options);
        });
        this.querySelectorAll('select[name="id"]').forEach(select => {
          select.addEventListener('change', () => {
            select.form.querySelector('[type="submit"]').disabled = !select.value || select.selectedOptions[0].disabled;
          }, options);
        });
        this.querySelector('[data-socks-dismiss]').addEventListener('click', () => {
          rememberDisclosure(false);
          details.open = false;
          summary.focus();
        }, options);
      }
      disconnectedCallback() {
        this.listeners?.abort();
        delete this.dataset.ready;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
